export default __webpack_public_path__ + "static/media/header.44e64597.png";